import gql from 'graphql-tag';

export const periodFields = `
  id
  name
  dateFrom  
  dateTo
  type
  description
`;

const key = `ListPeriodByDateRange`;
const query = gql`
query ${key}($from:String, $to:String) {
  listPeriods(filter:{and:{
    dateFrom:{ge:$from},
    dateTo:{lt:$to}
    }
  }, limit: 100) {
    nextToken
    items{
      ${periodFields}
    }
  }
}
`;

export const LIST_PERIOD_BY_DATE_RANGE = { key, query };
